import { TitleSection } from '../../../title-section'
import React from 'react'
import { Tab, Row, Nav, Col } from 'react-bootstrap'
import { FeatureTabContent } from '../../../feature-tab-content'

export const FeatureSection = () => (
  <section id="features" className="features">
    <div className="container">
      <TitleSection title="Features" description="Our Payroll Top Features" />

      <Tab.Container id="payroll-features-tab" defaultActiveKey="modern">
        <Row>
          <Col lg={3}>
            <Nav variant="tabs" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="modern">Modern technology, platform and design</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="custom-reports">Custom Reports</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="integrated-db">Integrated Database</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="state-of-the-art-producer">State-of-the-art Producer Payroll System</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="support-online">On-Line Support System</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>

          <Col lg={9} className="mt-4 mt-lg-0">
            <Tab.Content>
              <Tab.Pane eventKey="modern">
                <FeatureTabContent
                  title="Modern technology, platform and design."
                  subTitle="Apply industry web standard technologies to deliver the proper result."
                  description="Available for modern platform such as laptop, tablets, phone and even TV as long you use modern browser."
                  featureImage="/assets/img/payroll-app/producer-removebg-preview.png"
                />
              </Tab.Pane>
              <Tab.Pane eventKey="custom-reports">
                <FeatureTabContent
                  title="Custom Reports"
                  subTitle="Grab any data and generate the report the way you want it!"
                  description="Our PIVOTS based reporting tools provide customized reports in minutes and not hours. Save any custom PIVOT template and re-use it at your will!"
                  featureImage="/assets/img/payroll-app/ticketpivot-removebg-preview.png"
                />
              </Tab.Pane>
              <Tab.Pane eventKey="integrated-db">
                <FeatureTabContent
                  title="Integrated Database"
                  subTitle="Your data available in the cloud to access anywhere."
                  description="Plants, Labs, FSA Offices, and Haulers,all this information at your fingertips, no manual updating required at all."
                  featureImage="/assets/img/payroll-app/dashboard-removebg-preview.png"
                />
              </Tab.Pane>
              <Tab.Pane eventKey="state-of-the-art-producer">
                <FeatureTabContent
                  title="State-of-the-art Producer Payroll System"
                  description="Best in the industry, comprehensive while still easy to use."
                  featureImage="/assets/img/payroll-app/check-removebg-preview.png"
                />
              </Tab.Pane>
              <Tab.Pane eventKey="support-online">
                <FeatureTabContent
                  title="On-Line Support System"
                  extraContent={
                    <>
                      <p>Our Zendesk system provides...</p>
                      <ul>
                        <li>
                          <p>Support ticket entry, tracking of status</p>
                        </li>
                        <li>
                          <p>Support ticket history and review</p>
                        </li>
                        <li>
                          <p>A complete knowledge base and videos</p>
                        </li>
                        <li>
                          <p>Remote assistance on desktop and mobile platforms</p>
                        </li>
                      </ul>
                    </>
                  }
                  featureImage="/assets/img/features/support-email-customer.png"
                />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  </section>
)
